module.exports = __webpack_public_path__ + "img/yw-3.2ec072ca.svg";